/* nt-search-recents.js — header search restyle + recents/trending panel.

   Surfaces (both share [data-js-search-input] + the predictive-search wiring
   from component-predictive-search.js):
     • Desktop pill: .headerCustomSearchBar search-form.ninja-search-parent
     • Mobile drawer: sidebar-drawer#site-search-sidebar search-form

   Behavior:
     • Inactive: white pill, grey border, slight drop shadow, grey magnifier.
     • Focused: brand-blue border + soft blue halo, blue magnifier.
     • Focused with an EMPTY input → panel with RECENT SEARCHES (client-side,
       localStorage, most-recent-first, capped) and a static TRENDING list.
       Typing hides the panel (the predictive results take over); clearing
       shows it again; Escape / click-outside closes it.
     • Recents are recorded on form submit, on panel-row clicks, and on any
       /search?q= results-page view (covers predictive "see all" paths).

   Styling (pill restyle + panel) lives in theme.css — render-blocking, so
   first paint shows the new bar with no FOUC; this file is behavior-only.
   Loaded from layout/theme.liquid.

   AI-SEARCH AFFORDANCE (2026-07-08) — this file also injects:
     • a "✦ AI" hint pinned right inside both search pills, and
     • an "Ask AI to find it for you →" row pinned at the TOP of the panel
       (above Recent/Trending, which are untouched).
   AI HANDOFF (repointed 2026-07-13): clicking either affordance OPENS the
   site-wide Shinobi chat widget in a shopping context via the loader's
   window.ShinobiChat.open({query}) — any typed query is passed so Shinobi opens
   already knowing it (auto-sent as the first turn; fresh chats get the search
   greeting). Falls back to a plain /search?q= when the widget isn't loaded
   (Shinobi setting off, or a layout without the embed). The old /search?mode=ai
   contract is RETIRED (the surface no longer has an AI-mode landing). See
   .claude/rules/ai-search-mode-param.md. */
(function () {
  if (window.__ntSearchRecents) return;
  window.__ntSearchRecents = true;

  var LS_KEY = 'nt_recent_searches';
  var MAX_RECENTS = 4;
  /* Override source: window.NT_TRENDING_TERMS set inline in layout/theme.liquid on blanks pages; otherwise the DTF default below. */
  var TRENDING = (window.NT_TRENDING_TERMS && window.NT_TRENDING_TERMS.length)
    ? window.NT_TRENDING_TERMS
    : ['DTF Transfers', 'Gang Sheet', 'Blank t shirt', 'UV DTF Transfers'];

  /* ── Recents store ─────────────────────────────────────────────── */
  function getRecents() {
    try {
      var raw = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (t) { return typeof t === 'string' && t.trim(); }).slice(0, MAX_RECENTS) : [];
    } catch (e) { return []; }
  }
  function saveTerm(term) {
    term = String(term || '').replace(/\s+/g, ' ').trim();
    if (!term || term.length > 80) return;
    try {
      var list = getRecents().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, MAX_RECENTS)));
    } catch (e) {}
  }

  /* Record terms whenever a search results page is viewed. */
  try {
    if (location.pathname.indexOf('/search') === 0) {
      var q = new URLSearchParams(location.search).get('q');
      if (q) saveTerm(q);
    }
  } catch (e) {}

  /* ── Icons ───────────────────────────────────────────────────────
     fill/stroke are set as INLINE STYLES on each shape — the theme has
     document-scoped svg CSS that overrides presentation attributes
     (fill="none" alone renders the clock as a solid black disc). */
  function clockSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
             '<circle cx="12" cy="12" r="9" style="fill:none;stroke:#3b4754;stroke-width:1.8;"/>' +
             '<path d="M12 7.5V12l3 2" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
           '</svg>';
  }
  function trendSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
             '<path d="M3.5 16.5l5.2-5.2 3.6 3.6 7.2-7.4" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
             '<path d="M14.5 7.5h5v5" style="fill:none;stroke:#3b4754;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;"/>' +
           '</svg>';
  }

  /* ── AI handoff → Shinobi chat (see AI HANDOFF in the header comment) ─── */
  function closeSearchDropdown() {
    /* We no longer navigate away, so close the dropdown ourselves: drop the
       recents/trending open class, and blur the focused control (the ✦AI button
       / input) — the typing typeahead is focus-gated, so losing focus collapses
       it too. (The 2026-07-13 pointerdown-dismiss treats .nt-srch-ai-hint / the
       Ask-AI row as INSIDE targets, so it never fired before this click.) */
    document.querySelectorAll('.nt-srch-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    /* Mobile: search is a full-screen <sidebar-drawer> (#site-search-sidebar,
       z-index 10001 — ABOVE the Shinobi widget's 9998). Close it the theme's own
       way (its [data-js-close], which also clears the scroll-lock/overlay) or the
       widget we just opened would be hidden behind the drawer. */
    var drawer = document.querySelector('#site-search-sidebar.sidebar--opened');
    if (drawer) { var closeBtn = drawer.querySelector('[data-js-close]'); if (closeBtn) closeBtn.click(); }
    if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
  }
  /* blanks-origin flag: when the current page's header is blanks-branded
     (<main-header id="site-header" class="blankmode">, set by header.liquid's
     tabSection), tag outbound /search navigations with ctx=blanks so the results
     page first-paints the Blanks header. The form submit carries ctx via a hidden
     input; this covers the JS nav paths (recents rows + the AI fallback below). */
  function ntBlanksCtx() {
    var h = document.getElementById('site-header');
    return h && h.classList.contains('blankmode') ? 'ctx=blanks' : '';
  }
  /* source = which affordance opened the chat (search_bar_ai_icon /
     search_dropdown_ask_shinobi). The loader relays it as openSource and
     PF1 stores it on the chat record; it changes nothing on screen. */
  function aiNavigate(q, source) {
    q = String(q || '').replace(/\s+/g, ' ').trim();
    if (q) saveTerm(q);
    if (window.ShinobiChat && typeof window.ShinobiChat.open === 'function') {
      window.ShinobiChat.open({ query: q, source: source }); // opens the site-wide widget in shopping context
      closeSearchDropdown();
    } else {
      /* Widget not loaded (Shinobi off / layout without the embed) → plain search. */
      var _ctx = ntBlanksCtx();
      window.location.href = '/search' + (q ? '?q=' + encodeURIComponent(q) + (_ctx ? '&' + _ctx : '') : '');
    }
  }
  function sparkHTML() {
    /* Gradient text spark (background-clip) — deliberately NOT an inline SVG:
       the theme has document-scoped svg CSS, and inline-SVG <style> is banned. */
    return '<span class="nt-srch-spark" aria-hidden="true">✦</span>';
  }

  /* ── Panel ─────────────────────────────────────────────────────── */
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rowHTML(icon, term) {
    return '<button type="button" class="nt-srch-row" data-term="' + esc(term) + '">' +
             '<span class="nt-srch-row__icon">' + icon + '</span>' +
             '<span class="nt-srch-row__text">' + esc(term) + '</span>' +
           '</button>';
  }
  function panelHTML() {
    /* AI-SEARCH: single "Ask AI" line pinned at the very top (Minimal A) —
       no card/box; Recent/Trending render below exactly as before.
       GATED (2026-07-16): the AI row renders ONLY when the Customizer toggle
       enable_ai_search is on (window.__ntAiSearch === true, emitted in
       theme.liquid). Toggle OFF / setting absent → recents + trending render
       exactly as before, no AI row. */
    var html = (window.__ntAiSearch === true)
      ? '<div class="nt-srch-section nt-srch-section--ai">' +
          '<button type="button" class="nt-srch-row nt-srch-airow" data-ai-row>' +
            '<span class="nt-srch-row__icon nt-srch-airow__icon">' + sparkHTML() + '</span>' +
            '<span class="nt-srch-row__text nt-srch-airow__text">Ask Shinobi to find it for you</span>' +
            '<span class="nt-srch-airow__arrow" aria-hidden="true">→</span>' +
          '</button>' +
        '</div>'
      : '';
    var recents = getRecents();
    if (recents.length) {
      html += '<div class="nt-srch-section nt-srch-section--divided"><div class="nt-srch-label">Recent Searches</div>';
      for (var i = 0; i < recents.length; i++) html += rowHTML(clockSvg(), recents[i]);
      html += '</div>';
    }
    html += '<div class="nt-srch-section nt-srch-section--divided"><div class="nt-srch-label">Trending</div>';
    for (var j = 0; j < TRENDING.length; j++) html += rowHTML(trendSvg(), TRENDING[j]);
    html += '</div>';
    return html;
  }

  function enhance(sf) {
    if (!sf || sf.__ntSrchEnhanced) return;
    var input = sf.querySelector('[data-js-search-input]');
    var form = sf.querySelector('form');
    if (!input || !form) return;
    sf.__ntSrchEnhanced = true;
    sf.classList.add('nt-srch-enhanced');

    /* Unify the placeholder — the mobile drawer's translation says
       "Search for products"; match the desktop pill's AI-signalling copy
       (the desktop copy is server-rendered in sections/header.liquid).
       GATED (2026-07-16): the "ask anything" AI promise is part of the AI
       affordance, so only override when enable_ai_search is on. Toggle OFF /
       setting absent → leave the drawer's pre-existing (server-rendered)
       placeholder untouched. */
    if (window.__ntAiSearch === true && sf.closest('#site-search-sidebar')) input.placeholder = 'Search or ask anything…';

    /* AI-SEARCH: "✦ AI" hint pinned right inside the pill (styling in
       theme.css). Click → /search?mode=ai, carrying any typed query.
       GATED (2026-07-16): injected ONLY when the Customizer toggle
       enable_ai_search is on (window.__ntAiSearch === true). Toggle OFF /
       setting absent → no pill; the recents panel + dismiss handlers below
       are unaffected. */
    if (window.__ntAiSearch === true) {
      var aiHint = document.createElement('button');
      aiHint.type = 'button';
      aiHint.className = 'nt-srch-ai-hint';
      aiHint.setAttribute('aria-label', 'Ask Shinobi to find it for you');
      aiHint.innerHTML = sparkHTML() + '<span class="nt-srch-ai-hint__word">AI</span>';
      form.appendChild(aiHint);
      aiHint.addEventListener('click', function () { aiNavigate(input.value, 'search_bar_ai_icon'); });
    }

    var panel = document.createElement('div');
    panel.className = 'nt-srch-panel';
    sf.appendChild(panel);

    function show() {
      if (input.value.trim() !== '') { hide(); return; }
      panel.innerHTML = panelHTML();
      panel.classList.add('is-open');
    }
    function hide() { panel.classList.remove('is-open'); }

    input.addEventListener('focus', show);
    input.addEventListener('click', show);
    input.addEventListener('input', function () {
      if (input.value.trim() === '') show(); else hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
    /* Keep the input focused while tapping panel rows (mousedown fires
       before blur), so the click handler below still runs. */
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      /* AI-SEARCH: pinned "Ask AI" row → AI-mode handoff. */
      if (e.target.closest('[data-ai-row]')) { aiNavigate(input.value, 'search_dropdown_ask_shinobi'); return; }
      var row = e.target.closest('[data-term]');
      if (!row) return;
      var term = row.getAttribute('data-term') || '';
      saveTerm(term);
      var _ctx = ntBlanksCtx();
      window.location.href = '/search?q=' + encodeURIComponent(term) + (_ctx ? '&' + _ctx : '');
    });
    /* Dismiss on any outside pointer — CAPTURE phase + pointerdown so it fires
       BEFORE other handlers can stopPropagation (the old bubbling `click` here
       was silently blocked whenever an intermediate handler stopped the event)
       and before the click/navigation. A pointer INSIDE sf (the input OR the
       panel — sf contains both) is preserved, so a panel row's own click still
       runs and navigates; the dismiss never eats it. */
    document.addEventListener('pointerdown', function (e) {
      if (!sf.contains(e.target)) hide();
    }, true);
    /* (c) Focus leaving the search region entirely — keyboard tab-away. Guarded
       to a REAL relatedTarget outside sf: a mouse click on a panel row can blur
       with relatedTarget=null, and dismissing there would eat the row's click. */
    sf.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !sf.contains(e.relatedTarget)) hide();
    });
    /* (d) Dismiss when focus enters a cross-origin iframe (the AI-surface on
       /search). A real click inside a cross-origin iframe delivers no pointerdown
       to the parent, so (c-pointerdown) above never fires over the iframe region;
       and focus-into-iframe blurs with relatedTarget=null, which the focusout guard
       above deliberately ignores. Focusing an iframe blurs the top window and sets
       document.activeElement to the iframe — the reliable signal. activeElement===
       IFRAME scopes this to iframe focus, not plain tab-away. */
    window.addEventListener('blur', function () {
      if (document.activeElement && document.activeElement.tagName === 'IFRAME') hide();
    });
    form.addEventListener('submit', function () {
      var v = input.value.trim();
      if (v) saveTerm(v);
    });
  }

  /* ── Styles ────────────────────────────────────────────────────────
     ALL styling (pill restyle + panel) lives in theme.css — render-blocking,
     so a refresh never flashes the old grey-fill search bar. This file only
     drives behavior. */

  function init() {
    document.querySelectorAll('.headerCustomSearchBar search-form, #site-search-sidebar search-form').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
